<template>
  <footer class="p-4 text-center text-sm text-gray-600">
    <p>{{ $t('secure-info') }} {{ footerText }}</p>
  </footer>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { clients } from '@/config/clients';

export default {
  name: 'MedeaFooter',
  setup() {
    const { t } = useI18n();

    const getFooterText = () => {
      const theme = document.documentElement.getAttribute('data-theme');
      const clientName = clients[theme]?.clientName;

      return clientName && theme != 'default'
        ? t('footer-text-with-client', { clientName })
        : t('footer-text');
    };

    return {
      footerText: getFooterText(),
    };
  },
};
</script>
